import React from "react";

type PrimaryButtonProps = {
  label: string;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  className?: string;
  disabled?: boolean;
};

const PrimaryButton = ({
  label,
  onClick,
  className = "",
  disabled = false,
}: PrimaryButtonProps) => {
  return (
    <button
      type="button"
      disabled={disabled}
      onClick={onClick}
      className={[
        "inline-flex w-full items-center justify-center rounded-[10px] p-4 text-[16px] font-bold transition-colors",
        "bg-primary text-white hover:bg-[#000B54]",
        "disabled:cursor-not-allowed disabled:bg-gray-300 disabled:text-gray-500 disabled:hover:bg-gray-300",
        className,
      ].join(" ")}
    >
      {label}
    </button>
  );
};

export default PrimaryButton;
